
























import Vue from "vue";
import configProvider from "@/services/configProvider"

export default Vue.extend({
  data() {
    return {
      logoUrl: configProvider.get("LOGO_URL") || "",
      url: configProvider.get('INSTALL_MITM_CA_URL'),
    }
  },
  methods: {
    openUrl() {
      window.open('help/index', '_blank')
    }
  }
});
